import { Entidad } from "../../../data/Entidad";
import { _DICC_ALUMNO, _DICC_ALUMNO_FULL } from "../../../data/modulo/Alumno";

export function _BuscarAlumnoPanel(idAlumno: number): Entidad.IAlumno | null {
    let alumno = _DICC_ALUMNO.get(idAlumno);
    if (!alumno) {
        alumno = _DICC_ALUMNO_FULL.get(idAlumno);
        if (alumno?.IdChildMovimiento != Entidad.CNinioMovimiento.Graduado) {
            alumno = null;
        }
    }
    return alumno || null;
}